/* ═══════════════════════════════════════════════════════════════════════
   FizzyIQ — References popup
   Any element with [data-fref-open] anywhere on the page opens the
   references modal rendered by the References section (mode: popup/both).
   Closes on scrim click, the × button, or Escape. Body scroll is locked
   while open. z-index sits above the page header + sticky ATC.
   ═══════════════════════════════════════════════════════════════════════ */
(function () {
  if (window.__fizzyRefBooted) return;
  window.__fizzyRefBooted = true;

  function boot() {
    var modal = document.querySelector('[data-fref-modal]');
    if (!modal) return;
    var lastFocus = null;

    function open(e) {
      window.fizzyPopupMotion.reveal(modal, function () {
        if (e) e.preventDefault();
        lastFocus = document.activeElement;
        modal.hidden = false;
        modal.classList.add('is-open');
        document.body.classList.add('fref-modal-open');
        var closeBtn = modal.querySelector('.fref-modal-close');
        if (closeBtn) closeBtn.focus();
      });
    }
    function close() {
      window.fizzyPopupMotion.dismiss(modal, function () {
        modal.classList.remove('is-open');
        document.body.classList.remove('fref-modal-open');
        modal.hidden = true;
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      });
    }

    // Delegate trigger clicks so buttons in any other section work.
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-fref-open]')) { open(e); return; }
      if (!modal.classList.contains('is-open')) return;
      // Close on the × / scrim, OR any click on the backdrop outside the
      // dialog itself (clicking outside the popup closes it).
      if (e.target.closest('[data-fref-close]') ||
          (e.target.closest('[data-fref-modal]') && !e.target.closest('.fref-modal-dialog'))) {
        close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
